export enum ConjunctionEnum {
  Unknown,
  And,
  Or
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/models/conjunction.enum.ts